import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import ActionTiles from './ActionTiles';
import ConfidenceNumberContainer from './ConfidenceNumberContainer';
import OnOffTrackMessage from './OnOffTrackMessage';
import SavingsRunOut from './SavingsRunOut';

const StyledContainer = styled.div`
  height: 368px;
  background: linear-gradient(90deg, #006894 0%, #004466 50%);
  background-size: 100% 263px;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  padding: 48px 0;

  @media (width: 1024px) {
    padding: 48px 40px 40px;
  }

  @media (min-width: 1024px) and (max-width: 1199px) {
    padding: 30px 48px 40px;
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    padding: 30px 40px 40px;
  }
  @media only screen and (max-width: 1024px) {
    height: 550px;
    background-size: auto;
  }
  @media (max-width: 768px) {
    height: 600px;
  }
  @media (max-width: 767px) {
    padding: 24px 16px;
    height: 650px;
  }
`;
const StyledInnerContainer = styled.div`
  width: 1122px;
  @media only screen and (max-width: 1024px) {
    width: 100%;
  }
`;
const StyledOnTrackOffTrackContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0px 0 16px 0;
  max-width: 1122px;
  @media only screen and (max-width: 1024px) {
    padding: 20px 0 35px 0;
  }
  @media only screen and (max-width: 1023px) {
    flex-direction: column;
    width: 100%;
  }
`;

const StyledDivider = styled.div`
  @media only screen and (max-width: 1023px) {
    border: 1px solid #05c3de;
  }
`;

interface Props {
  onTrackMessage: string;
  offTrackMessage: string;
}

class MessageContainer extends Component<Props> {
  props: any;

  render(): JSX.Element {
    return (
      <StyledContainer>
        <StyledInnerContainer>
          <StyledOnTrackOffTrackContainer>
            <OnOffTrackMessage {...this.props} />
            <SavingsRunOut />
            <StyledDivider />
            <ConfidenceNumberContainer />
          </StyledOnTrackOffTrackContainer>
          <ActionTiles />
        </StyledInnerContainer>
      </StyledContainer>
    );
  }
}

export default connect(null, null)(MessageContainer);
